const stomp = {
  state: {
    client: null
  },
  mutations: {
    stompConnected: function (state, client) {
      state.client = client
    },
    stompDisconnect: function (state) {
      state.client = null
    }
  }
}

export default stomp
